import { useEffect, useState, useCallback } from "react";

global.appVersion = process.env.REACT_APP_VERSION;

const CacheBuster = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isLatestVersion, setIsLatestVersion] = useState(false);

  const refreshCacheAndReload = () => {
    if (caches) {
      caches.keys().then(names => {
        for (let name of names) {
          caches.delete(name);
        }
      });
    }

    window.location.reload(true);
  };

  const cacheJudge = useCallback(async () => {
    try {
      const response = await fetch("/meta.json", { cache: "no-store" });
      const meta = await response.json();
      const shouldForceRefresh =
        meta.commitVersion !== global.appVersion &&
        window.location.hostname !== "localhost";

      setIsLatestVersion(!shouldForceRefresh);
      setLoading(false);

      if (shouldForceRefresh) {
        console.log("Forcing Cache Refresh");
        refreshCacheAndReload();
      }
    } catch (e) {
      console.error("Cache judge failed", e);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    cacheJudge();
    const interval = setInterval(cacheJudge, 600000);
    return () => clearInterval(interval);
  }, [cacheJudge]);

  return children({ loading, isLatestVersion, refreshCacheAndReload });
};

export default CacheBuster;
